import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

toast.configure();
export const CourceOptionFilters = memo((props) => {
  const { cource_id, options, using_option_ids, disabled } = props;
  // 初期設定
  const [usingOptionIds, setUsingOptionIds] = useState([]);
  useEffect(() => {
    setUsingOptionIds(using_option_ids);
  }, [])

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeOption = (event) => {
    const { value } = event.target;
    setUsingOptionIds(value);
  };

  const displayNames = (selected) => {
    var dispName = [];
    selected.map(selected_value => {
      options.map((option) => {
        if (option.id === selected_value) {
          dispName.push(option.name_ja);
        }
      })
    })
    return dispName.join(', ');
  }

  const onClickOptionsSubmit = () => {
    var data = { cource_option: { option_ids: usingOptionIds }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/cources/${cource_id}/cource_options`, data)
    .then(resp => {
      console.log(resp.data);
      setUsingOptionIds(resp.data);
      notify("success", "CourceOption successfully created!");
    })
    .catch(e => {
      console.log("api ng");
      console.log(e.response);
      setUsingOptionIds(using_option_ids);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "CourceOption create Error!");
    })
  }

  return (
    <>
      <FormControl sx={{ mr: 1, width: 250 }} size="small" disabled={disabled}>
        <InputLabel id="multiple-checkbox-label">Op</InputLabel>
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          value={usingOptionIds}
          onChange={onChangeOption}
          input={<OutlinedInput label="Op" />}
          renderValue={(selected) => displayNames(selected)}
        >
          {options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox checked={usingOptionIds.indexOf(option.id) > -1} />
              <ListItemText primary={option.name_ja} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <button
        onClick={onClickOptionsSubmit}
        className='btn btn-primary' 
        title="[生研]コースオプション設定実行"
        disabled={disabled}
      >
        <i className='fas fa-filter' />
      </button>
    </>
  );
});
